import Dexie from 'dexie'

export const createDexieInstance = (
  dbName = 'components-db',
  customSchema = {},
  version = 1
) => {
  const db = new Dexie(dbName)

  const defaultSchema = {
    cwarning: 'id, savedAt, version'
  }

  const schema = { ...defaultSchema, ...customSchema }

  db.version(version).stores(schema)

  return db
}

export const db = createDexieInstance()
export const { cwarning } = db
